<!-- 权限管理 -->
<template>
	<div class="meau">
		<div class="left">
			<div class="border_box">
				<h3 class="tree-h3">权限
					<span v-if ="!batchAuthState" class="header_btn_box" style="margin-right:20px;">
						<el-button type="text" @click="showadd">
							<i class="el-icon-plus" style="cursor: pointer;">新增</i>
						</el-button>
						<el-button type="text" @click="batchAuth">
							<i class="el-icon-s-check" style="cursor:pointer;">批量授权</i>
						</el-button>
					</span>
				</h3>
				<div class="tree_box">
					<el-tree
					ref="tree"
					:data="menuList"
					:props="defaultProps"
					node-key="menuId"
					default-expand-all
					style="padding: 0 20px 0 20px;"
					@node-drag-start="handleDragStart"
					@node-drag-enter="handleDragEnter"
					@node-drag-leave="handleDragLeave"
					@node-drag-over="handleDragOver"
					@node-drag-end="handleDragEnd"
					@node-drop="handleDrop"
					@node-click="currentlySelected"
					:show-checkbox="batchAuthState"
					:default-checked-keys="chooseMenu"
					@check="handleCheckChange"
					draggable
					:allow-drop="allowDrop"
					:allow-drag="allowDrag">
						<span class="custom-tree-node" slot-scope="{ node,data }">
							<span>
								<i :class="data.menuIco"></i> {{ node.label }}
								<span v-if="data.menuType == 'menu'" style="color: #0F81FB;">(菜单)</span>
								<span v-if="data.menuType == 'button'" style="color: #E6A23C;">(按钮)</span>
								<span v-if="data.menuType == 'auth'" style="color: #ff4949;">(授权)</span>
							</span>
							<span class="icons" v-if="!batchAuthState">
								<el-button type="text" @click.stop="showadd(node)">
									<i class="el-icon-plus"></i>
								</el-button>
								<el-button type="text" @click.stop="showedit(node)">
									<i class="el-icon-edit"></i>
								</el-button>
								<el-button type="text" @click.stop="open(node)">
									<i class="el-icon-delete"></i>
								</el-button>
							</span>
						</span>
					</el-tree>
					<!-- <div v-if="batchAuthState" class="footer" style="text-align: center;margin-bottom: 10px">
						<el-button type="primary" style="float: right; margin-right: 30px;" @click="banckBoole()">返回</el-button>
						<el-button style="float: right;" @click="seceltRule()">选择角色</el-button>
					</div> -->
				</div>
			</div>
		</div>
		<manageAuth ref="manageAuth" @commit="commitAuth" style="margin-left: 20px;" />
		<i class="el-icon-right" style="font-size: 40px; color: gray; margin: 200px 10px;" v-if="batchAuthState"></i>
		<autoMenu ref="addEditAuto" :optionDatadd="autoMenuList" type="menu" style=" flex-shrink:0;" @close="batchAuthState = false"></autoMenu>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import IconSelect from './components/IconSelect/index'
import autoMenu from './components/autoMenu'

import manageAuth from "./components/manageAuth";

export default {
	components: {
		IconSelect,
		autoMenu,
		manageAuth
	},
	data() {
		return {
			optionMenu: [],
			// 是否在批量授权
			batchAuthState: false,
			data: [],
			startParendId: null,
			defaultProps: {
				children: 'nodes',
				label: 'menuName'
			},
			menuList: [],
			chooseMenu: [],
			prantRoleList: [],
			menuSorts: [],
			autoMenuList: [],
			DragOverPage: null,
		}
	},
	mounted() {
		this.getMenuList()
	},
	computed: {
		...mapGetters([
			'userInfo',
		])
	},
	watch: {
		"formData.viewUrl": {
			handler(newValue, oldValue) {
				if (newValue.length > 0) {
					this.formData.menuUrl = "/iframe";
				} else {
					this.formData.menuUrl = "";
				}
			},
		},
		batchAuthState: function(newValue,oldValue){
			this.$refs.tree.setCheckedKeys([]);
			this.autoMenuList = [];
		}
	},
	methods: {
		handleCheckChange(data, checked) {
			let operate = this.chooseMenu ? this.chooseMenu : []
			operate = checked.checkedKeys.concat(checked.halfCheckedKeys)
			this.autoMenuList = operate
		},

		seceltRule() {
			this.$refs.addEditAuto.onAdd()
			// this.prantRoleList = this.autoMenuList
		},
		// 批量授权
		batchAuth() {
			this.$refs.manageAuth.close()
			this.batchAuthState = true;
			this.$refs.addEditAuto.onAdd(); // 打开角色选择
		},
		// 取消批量授权
		banckBoole() {
			this.batchAuthState = false
		},
		getMenuList() {
			this.$api.getMenuSelco().then(res => {
				let code = res.errcode
				if (code == 0) {
					let menuListSource = res.data
					this.menuList = this.translateDataToTree(menuListSource);
				}
			}).catch(() => {})
		},
		commitAuth(operType, data) {
			console.log(operType, data);
			if (operType == "create") {
				this.addMenu(data);
			} else if (operType == "update") {
				this.editMenuAgli(data);
			}
		},
		addMenu(data) {
			if (!data.menuName) {
				this.$message.error('必填项不能为空!')
				return false
			}
			if (!data.menuUrl && data.menuType == 'menu') {
				this.$message.error('必填项不能为空!')
				return false
			}
			this.$api.getMenuSaves({
				...data
			}).then(res => {
				if (res.errcode == 0) {
					this.$message.success('添加成功!')
					this.getMenuList()
				}
			}).catch(res => {})
		},
		// 排序请求
		editMenu(ord) {
			if (!this.editData.menuName) {
				this.$message.error('必填项不能为空!')
				return false
			}
			if (!this.editData.menuUrl && this.editData.menuType == 'menu') {
				this.$message.error('必填项不能为空!')
				return false
			}
			this.$api.menuUpdateSort({
				...this.editData,
				menuSorts: ord
			}).then(res => {
				if (res.errcode == 0) {
					this.$message.success('修改成功!')
					this.getMenuList()
				}
			}).catch(res => {
				// this.$message.error(res.errmsg)
			})
		},
		// 修改权限
		editMenuAgli(data) {
			if (!data.menuName) {
				this.$message.error('必填项不能为空!')
				return false
			}
			if (!data.menuUrl && !data.menuType == 'menu') {
				this.$message.error('必填项不能为空!')
				return false
			}
			this.$api.getMenuUpdates({
				...data,
			}).then(res => {
				if (res.errcode == 0) {
					this.$message.success('修改成功!')
					this.showEdit = false;
					this.getMenuList()
				}
			}).catch(res => {})
		},

		removeMenu(param) {
			this.$api.getMenuDeletes(param.data.menuId).then(res => {
				if (res.errcode == 0) {
					this.getMenuList()
				}
			}).catch(res => {})
		},



		open(param) {
			this.$confirm('一旦删除，该条菜单将永久消失。', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'error'
			}).then(() => {
				this.removeMenu(param)
				this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		Dragopen(param) {
			this.$confirm('确定要移动此菜单吗?', '提示bb', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'error'
			}).then(() => {
				// this.removeMenu(param)
				this.editMenu(param)
			}).catch(() => {
				this.getMenuList()
				this.showEdit = false;
				this.$message({
					type: 'info',
					message: '已取消拖拽'
				});
			});
		},

		Dragopen2() {
			this.$confirm('确定要移动此菜单吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'error'
			}).then(() => {
				// this.removeMenu(param)
				this.editMenuAgli()
			}).catch(() => {
				this.getMenuList()
				this.showEdit = false;
				this.$message({
					type: 'info',
					message: '已取消拖拽'
				});
			});
		},




		showadd(param) {
			let data = null;
			if (param) data = param.data;
			this.manageAuthOpen("create", data);
		},
		showedit(param) {
			this.manageAuthOpen("update", param.data);
		},
		// 点出行事件
		currentlySelected(data, Node) {
			this.manageAuthOpen("view", data);
		},
		manageAuthOpen(operType,data){
			if(this.batchAuthState) return false;
			this.$refs.manageAuth.openManageAuth(operType, data);
		},





		handleDragStart(node, event) {
			this.editData = JSON.parse(JSON.stringify(node.data))
			this.startParendId = node.data.parentMenuId
		},
		handleDragEnter(draggingNode, dropNode, ev) {

		},
		handleDragLeave(draggingNode, dropNode, ev) {},
		handleDragOver(draggingNode, dropNode, ev) {
			this.DragOverPage = dropNode.data.orderNumber

		},
		handleDragEnd(draggingNode, dropNode, dropType, ev) {
			// this.editData.parentMenuId = dropNode.data.parentMenuId

			// this.Dragopen2()
		},
		handleDrop(draggingNode, dropNode, dropType, ev) {
			if (this.startParendId == dropNode.data.parentMenuId) {
				let obj = {
					arr: []
				}
				for (const [index, item] of dropNode.parent.childNodes.entries()) {
					item.data.orderNumber = index + 1;
					obj.arr.push([item.data.menuId, item.data.orderNumber])
				}
				this.menuSorts.push(obj.arr)
				this.Dragopen(obj.arr)
			} else {
				this.editData.parentMenuId = dropNode.data.parentMenuId
				for (const [index, item] of dropNode.parent.childNodes.entries()) {
					item.data.orderNumber = index + 1;
					this.editData.orderNumber = item.data.orderNumber
				}

				this.Dragopen2()

				// this.Dragopen()
			}
		},

		allowDrop(draggingNode, dropNode, type) {
			return true;
		},
		allowDrag(draggingNode) {
			return true;
		},
		translateDataToTree(arr) {
			return arr.filter((father) => {
				let branchArr = arr.filter((child) => father.menuId == child.parentMenuId)
				branchArr.length > 0 ? father.nodes = branchArr : ''
				return father.parentMenuId == ''
			})
		},
	}
}
</script>
<style lang="scss" scoped>
.meau {
	padding: 20px;
	height: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;

	.left {
		width: 450px;
		height: 100%;
		.tree-h3 {
			height: 44px;
			line-height: 44px;
			background: #F6F7F9;
			border-bottom: 1px solid #E8E8E8;
			padding-left: 24px;
			color: #3C4353;
		}

		.border_box {
			height: 100%;
			border-radius: 4px 4px 0px 0px;
			border: 1px solid #E6E9EF;
			.tree_box{
				height: calc(100% - 44px);
				overflow: scroll;
				padding: 0px;
			}
		}
	}

	.custom-tree-node {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 8px;
	}

	.el-select,
	.el-input {
		width: 60%;
	}
}

.footer {
	display: flex;
	justify-content: center;
	margin-top: 20px;
}

.icons{
	color: #409eff;
	i{
		font-size: 16px;
	}
}
.header_btn_box{
	float: right;
	font-size: 16px;
	color:#409eff;
	user-select: none;
}
</style>